import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { FormContainer, FormFieldRow, FormFieldColumn, FormSection, FormField, FormInputFull, FormInput, FormTextArea, FormLabel, FormSubHeading, FormItalicHeading, FormSectionPadding, FormFileName, FormInputCharCount } from '../../../styles/form-styles.js';
import colors from '../../../styles/colors';
import { history } from '../../../routers/AppRouter';
import { shortenFileName } from '../../../utility/string-utils';
import { createMicrosite, getMicrosite, updateMicrosite } from '../../../actions/microsite';
import Spinner from "../../../components/Spinner";

import Dropzone from 'react-dropzone';
import {
  base64StringtoFile,
  downloadBase64File,
  extractImageFileExtensionFromBase64,
  image64toCanvasRef
} from '../../../utility/reusable-utils';

import ABButton from '../../../components/ABButton';
import ABSmallButton from '../../../components/ABSmallButton';
import { saveMultiplePhotos, saveSingleFile } from '../../../actions/upload';
import { updateMicrositeSubmission } from '../../../actions/microsite-submission';
import { setLocation } from '../../../actions/location';
import { getMicrositeSetting, updateMicrositeSetting } from '../../../actions/microsite-settings';

const PageWrapper = styled.div`
  max-width: 1100px;
  margin: 0 auto;
`;

const PageHeading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
`;

const PageTitle = styled.div`
  color: ${colors.blue};
  font-size: 30px;
  padding: 30px 0;
`;

const SkipSection = styled.form`
  font-size: 15px;
  display: flex;
  align-items: center;
  input {
    margin-right: 5px;
  }
`;

const ActionButtons = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 40px 0;
  div:first-child {
    padding-right: 10px;
  }
`;

const RightButton = styled.div`
  display: flex;
  justify-content: space-around;
`;

const ImagePreview = styled.img`
  max-width: 300px;
  max-height: 150px;
  object-fit: cover;
  margin-left: 20px;
`;

const CenterImage = styled.div`
  padding: 0 0 15px 0;
`;

const ImageSelection = styled.div`
  display: flex;
  // max-width: 350px;
  max-height: 150px;
  border: none;
  font-weight: bold;
  font-size: 18px;
  color: #1194F6;
  cursor: pointer;
  outline: none;
`;

const UploadButtonContainer = styled.div`
  display: flex;
  align-items: center;
`;

const ValidationError = styled.div`
  color: red;
  padding-left: 10px;
  font-weight: normal;
  font-size: 15px;
`;

const FileRow = styled.div`
  padding: 5px 10px;
  button {
    margin-left: 10px;
  }
`;

const FileName = styled.div`
  margin: 10px 0;
  font-size: 14px;
`;

const UploadSpinner = styled.div`
  font-size: 14px;
  padding: 20px 0;
  max-width: 1365px;
  text-align: center;
`;

const imageMaxSize = 1000000000; // bytes
const acceptedFileTypes = 'image/x-png, image/png, image/jpg, image/jpeg, image/gif';
const acceptedFileTypesArray = acceptedFileTypes.split(",").map((item) => { return item.trim() });

class Focus extends Component {

  constructor(props) {
    super(props);

    this.state = {
      name: '',
      description: '',
      buttonText: '',
      buttonLink: '',

      imgSrc: null,
      imgSrcExt: null,
      uploadedFile: null,
      uploadedFileName: '',

      imgSrc2: null,
      imgSrcExt2: null,
      uploadedFile2: null,
      uploadedFileName2: '',

      imgSrc3: null,
      imgSrcExt3: null,
      uploadedFile3: null,
      uploadedFileName3: '',

      imgSrc4: null,
      imgSrcExt4: null,
      uploadedFile4: null,
      uploadedFileName4: '',

      imageUploading: false,
      fileCountError: false,
      imageSizeError1: false,
      imageSizeError2: false,
      imageSizeError3: false,
      imageSizeError4: false,
      showSection: false,

    };

  }

  componentDidMount = () => {
    if (this.props.match.params.id) {
      this.props.getMicrosite(this.props.match.params.id);
      this.props.getMicrositeSetting(this.props.match.params.id);
    }
  };

  componentDidUpdate(prevProps) {
    if (this.props.microsite !== prevProps.microsite) {
      this.loadFields();
    }
    if (this.props.micrositeSetting !== prevProps.micrositeSetting) {
      this.setState({
        showSection: this.props.micrositeSetting.showFeaturedProduct || false
      });
    }
  }

  loadFields = () => {

    this.setState({
      name: this.props.microsite.featureProductName,
      description: this.props.microsite.featureProductDescription,
      buttonText: this.props.microsite.featureProductButtonText,
      buttonLink: this.props.microsite.featureProductButtonLink,
      uploadedFileName: this.props.microsite.featureProductBannerImage || '',
      uploadedFileName2: this.props.microsite.featureProductImage1 || '',
      uploadedFileName3: this.props.microsite.featureProductImage2 || '',
      uploadedFileName4: this.props.microsite.featureProductImage3 || ''
    });
  };

  onNextClick = (close) => {

    if (!this.state.imageSizeError1 && !this.state.imageSizeError2 && !this.state.imageSizeError3 && !this.state.imageSizeError4) {

      this.props.setLocation('additional-products');

      if (this.state.uploadedFile || this.state.uploadedFile2 || this.state.uploadedFile3 || this.state.uploadedFile4) {
        this.setState({ imageUploading: true });

        let formattedCompanyName = this.props.microsite.company.split(' ').join('-').toLowerCase();

        let allCloudFrontUrls = [];
        let allUploadedFiles = [];

        if (this.state.uploadedFile) {
          allUploadedFiles.push({ fileNumber: 1, file: this.state.uploadedFile });
        }

        if (this.state.uploadedFile2) {
          allUploadedFiles.push({ fileNumber: 2, file: this.state.uploadedFile2 });
        }

        if (this.state.uploadedFile3) {
          allUploadedFiles.push({ fileNumber: 3, file: this.state.uploadedFile3 });
        }

        if (this.state.uploadedFile4) {
          allUploadedFiles.push({ fileNumber: 4, file: this.state.uploadedFile4 });
        }

        let count = 0;
        allUploadedFiles.map((item, index) => {
          this.props.saveSingleFile(item.file, formattedCompanyName, 'microsites')
            .then((cloudFrontUrl) => {
              console.log('cloudFrontUrl: ', cloudFrontUrl);
              allCloudFrontUrls.push({ fileNumber: item.fileNumber, cloudFrontUrl: cloudFrontUrl });
              console.log('cloudfront url returned: ', cloudFrontUrl);
              count++;
              if (count === allUploadedFiles.length) {
                this.setState({ imageUploading: false });
                this.saveForm(allCloudFrontUrls, close);
              }
            });
        });
      } else {
        this.saveForm(null, close);
      }

    }
  };


  saveForm = (allCloudFrontUrls, close) => {

    let micrositeSetting = {
      showFeaturedProduct: this.state.showSection
    };

    let microsite = {
      featureProductName: this.state.name,
      featureProductDescription: this.state.description,
      featureProductButtonText: this.state.buttonText,
      featureProductButtonLink: this.state.buttonLink,
      userId: this.props.microsite.userId
    };

    if (allCloudFrontUrls) {
      allCloudFrontUrls.map((item, index) => {
        switch (item.fileNumber) {
          case 1:
            console.log('image 1');
            microsite.featureProductBannerImage = item.cloudFrontUrl;
            break;
          case 2:
            console.log('image 2');
            microsite.featureProductImage1 = item.cloudFrontUrl;
            break;
          case 3:
            console.log('image 3');
            microsite.featureProductImage2 = item.cloudFrontUrl;
            break;
          case 4:
            console.log('image 4');
            microsite.featureProductImage3 = item.cloudFrontUrl;
            break;
          default:
          // should only be 4 max
        }
      });
    }

    this.props.updateMicrosite(microsite, this.props.microsite.id);

    let micrositeSubmission = {
      featuredProduct: true
    };
    this.props.updateMicrositeSubmission(micrositeSubmission, this.props.microsite.id);
    this.props.updateMicrositeSetting(micrositeSetting, this.props.microsite.id);

    if (close) {
      history.push(`../${this.props.microsite.id}`);
      return;
    }
  };

  onNameChange = (e) => {
    const name = e.target.value;
    if (name.length <= 50) {
      this.setState(() => ({ name }));
    }
  };

  onDescriptionChange = (e) => {
    const description = e.target.value;
    if (description.length <= 600) {
      this.setState(() => ({ description }));
    }
  };

  onHeaderButtonTextChange = (e) => {
    const buttonText = e.target.value;
    if (buttonText.length <= 25) {
      this.setState(() => ({ buttonText }));
    }
  };

  onHeaderButtonLinkChange = (e) => {
    const buttonLink = e.target.value;
    this.setState(() => ({ buttonLink }));
  };

  toggleCheckbox = (e) => {
    const showSection = e.target.checked;
    this.setState(() => ({ showSection: !showSection }));
  };

  // File upload

  verifyFile = (files) => {
    if (files && files.length > 0) {
      const currentFile = files[0];
      const currentFileType = currentFile.type;
      const currentFileSize = currentFile.size;
      if (currentFileSize > imageMaxSize) {
        alert(`This file is not allowed. ${currentFileSize} bytes is too large`);
        return false
      }
      if (!acceptedFileTypesArray.includes(currentFileType)) {
        console.log('file type not allowed!');
        alert('This file is not allowed. Only images are allowed.');
        return false
      }
      return true
    }
  };

  handleOnDrop(files, rejectedFiles, fileNumber, customSize) {

    if (rejectedFiles && rejectedFiles.length > 0) {
      this.verifyFile(rejectedFiles)
    }

    if (files && files.length > 0) {
      const isVerified = this.verifyFile(files);
      if (isVerified) {
        // imageBase64Data
        const currentFile = files[0];
        const myFileItemReader = new FileReader();
        myFileItemReader.addEventListener("load", () => {
          // console.log(myFileItemReader.result)
          const myResult = myFileItemReader.result;
          if (customSize) {
            this.isValidImageSizeCustom(myResult, fileNumber)
          } else {
            this.isValidImageSize(myResult, 1920, 375, fileNumber);
          }
          this.fileStateToUpdate(myResult, currentFile, files[0].name, fileNumber);
        }, false);

        myFileItemReader.readAsDataURL(currentFile)

      }
    }

  }

  fileStateToUpdate = (myResult, currentFile, fileName, fileNumber) => {
    if (fileNumber === 1) {
      this.setState({
        imgSrc: myResult, //this is the base64 code for preview
        imgSrcExt: extractImageFileExtensionFromBase64(myResult),
        uploadedFile: currentFile,
        uploadedFileName: fileName
      })
    } else if (fileNumber === 2) {
      this.setState({
        imgSrc2: myResult, //this is the base64 code for preview
        imgSrcExt2: extractImageFileExtensionFromBase64(myResult),
        uploadedFile2: currentFile,
        uploadedFileName2: fileName
      })
    } else if (fileNumber === 3) {
      this.setState({
        imgSrc3: myResult, //this is the base64 code for preview
        imgSrcExt3: extractImageFileExtensionFromBase64(myResult),
        uploadedFile3: currentFile,
        uploadedFileName3: fileName
      })
    } else if (fileNumber === 4) {
      this.setState({
        imgSrc4: myResult, //this is the base64 code for preview
        imgSrcExt4: extractImageFileExtensionFromBase64(myResult),
        uploadedFile4: currentFile,
        uploadedFileName4: fileName
      })
    }
  };

  imageCheck() {
    if (this.state.imgSrc != null) {
      return <FormFileName>{this.state.uploadedFileName}</FormFileName> // just uploaded
    } else if (this.state.uploadedFileName !== null) {
      // return <ImagePreview src={this.state.imgSrc} />
      return <FormFileName>{shortenFileName(this.state.uploadedFileName)}</FormFileName> // pulled from server
    } else {
      return (
        <div></div>
      )
    }
  }

  imageCheck2() {
    if (this.state.imgSrc2 != null) {
      return <FormFileName>{this.state.uploadedFileName2}</FormFileName> // just uploaded
    } else if (this.state.uploadedFileName2 !== null) {
      // return <ImagePreview src={this.state.imgSrc} />
      console.log('this.state.uploadedFileName: ', this.state.uploadedFileName);
      return <FormFileName>{shortenFileName(this.state.uploadedFileName2)}</FormFileName> // pulled from server
    } else {
      return (
        <div></div>
      )
    }
  }

  imageCheck3() {
    if (this.state.imgSrc3 != null) {
      return <FormFileName>{this.state.uploadedFileName3}</FormFileName> // just uploaded
    } else if (this.state.uploadedFileName3 !== null) {
      // return <ImagePreview src={this.state.imgSrc} />
      return <FormFileName>{shortenFileName(this.state.uploadedFileName3)}</FormFileName> // pulled from server
    } else {
      return (
        <div></div>
      )
    }
  }

  imageCheck4() {
    if (this.state.imgSrc4 != null) {
      return <FormFileName>{this.state.uploadedFileName4}</FormFileName> // just uploaded
    } else if (this.state.uploadedFileName4 !== null) {
      // return <ImagePreview src={this.state.imgSrc} />
      return <FormFileName>{shortenFileName(this.state.uploadedFileName4)}</FormFileName> // pulled from server
    } else {
      return (
        <div></div>
      )
    }
  }

  isValidImageSize = (fileDetails, width, height, fileNumber) => {
    // getting image size, kind of strange with inline fuction so had to set a reference to the global this
    // to call the setState out of the function, arrow function wouldn't work with the image.onload
    let globalThis = this;
    let image = new Image();
    image.src = fileDetails;
    image.onload = function () {
      if (this.width === width && this.height === height) {
        globalThis.setSingleImageError(false, fileNumber);
      } else {
        globalThis.setSingleImageError(true, fileNumber);
      }
    };
  };

  isValidImageSizeCustom = (fileDetails, fileNumber) => {
    // getting image size, kind of strange with inline fuction so had to set a reference to the global this
    // to call the setState out of the function, arrow function wouldn't work with the image.onload
    let globalThis = this;
    let image = new Image();
    image.src = fileDetails;
    image.onload = function () {
      if (this.width >= 563 && this.height >= 600 && this.width <= 798 && this.height <= 851) {
        globalThis.setSingleImageError(false, fileNumber);
      } else {
        globalThis.setSingleImageError(true, fileNumber);
      }
    };
  };

  setSingleImageError = (showError, fileNumber) => {
    if (fileNumber === 1) {
      this.setState({
        imageSizeError1: showError
      });
    } else if (fileNumber === 2) {
      this.setState({
        imageSizeError2: showError
      });
    } else if (fileNumber === 3) {
      this.setState({
        imageSizeError3: showError
      });
    } else if (fileNumber === 4) {
      this.setState({
        imageSizeError4: showError
      });
    }
  };

  render() {
    return (
      <>
        <PageWrapper>
          <PageHeading>
            <PageTitle>Focus</PageTitle>
            <SkipSection>
              <input
                type='checkbox'
                checked={!this.state.showSection}
                onChange={(e) => this.toggleCheckbox(e)}
              />
              Disable this section
            </SkipSection>
          </PageHeading>
          <FormContainer>
            <FormSection>
              <FormSubHeading>Product Name:</FormSubHeading>
              <FormItalicHeading>Product/Service Name should not exceed 50 characters including spaces.</FormItalicHeading>
              <div>
                <FormField>
                  <FormInputFull
                    value={this.state.name}
                    onChange={this.onNameChange}
                    type="text"
                    rows="10"
                    cols="10"
                  />
                  {
                    this.state.name &&
                    <FormInputCharCount>Char count: {this.state.name.length}</FormInputCharCount>
                  }
                </FormField>
              </div>

              <FormSectionPadding>
                <FormSubHeading>Description:</FormSubHeading>
                <FormItalicHeading>The Featured Product Description should not exceed 600 characters, including spaces.</FormItalicHeading>
                <div>
                  <FormField>
                    <FormTextArea
                      value={this.state.description}
                      onChange={this.onDescriptionChange}
                      type="text"
                      rows="10"
                      cols="10"
                    />
                    {
                      this.state.description &&
                      <FormInputCharCount>Char count: {this.state.description.length}</FormInputCharCount>
                    }
                  </FormField>
                </div>
              </FormSectionPadding>

              <FormSectionPadding>
                <FormSubHeading>Button Text:</FormSubHeading>
                <FormItalicHeading>Not to exceed 25 characters including spaces.</FormItalicHeading>
                <div>
                  <FormInputFull
                    value={this.state.buttonText}
                    onChange={this.onHeaderButtonTextChange}
                    type="text"
                    rows="10"
                    cols="10"
                  />
                  {
                    this.state.buttonText &&
                    <FormInputCharCount>Char count: {this.state.buttonText.length}</FormInputCharCount>
                  }
                </div>
              </FormSectionPadding>

              <FormSectionPadding>
                <FormSubHeading>Link URL:</FormSubHeading>
                <div>
                  <FormInputFull
                    value={this.state.buttonLink}
                    onChange={this.onHeaderButtonLinkChange}
                    type="text"
                    rows="10"
                    cols="10"
                  />
                </div>
              </FormSectionPadding>

            </FormSection>

            <FormSection>

              <FormSubHeading>Featured Product/Service Banner Image:</FormSubHeading>
              <FormItalicHeading>The submitted Banner Image should be exactly 1920 pixels wide and 375 pixels tall.</FormItalicHeading>
              <div>
                <FormField>
                  <CenterImage>
                    <Dropzone
                      onDrop={(acceptedFiles) => this.handleOnDrop(acceptedFiles, null, 1)}
                      multiple={false}
                      accept={acceptedFileTypes}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <section>
                          <ImageSelection {...getRootProps()}>
                            <input {...getInputProps()} />
                            <ABSmallButton title="File Upload" />
                            <UploadButtonContainer>
                              {this.imageCheck()}
                              {
                                this.state.imageSizeError1 &&
                                <ValidationError>Invalid Image Size</ValidationError>
                              }
                            </UploadButtonContainer>
                          </ImageSelection>
                          {
                            this.state.uploadedFileName !== '' &&
                            <button onClick={() => this.setState({ uploadedFileName: null })}>Remove X</button>
                          }
                        </section>
                      )}
                    </Dropzone>
                  </CenterImage>
                </FormField>
              </div>

              <FormSectionPadding>
                <FormSubHeading>Featured Product/Service Images:</FormSubHeading>
                <FormItalicHeading>The submitted Product Images should be at least 563 pixels wide and 600 pixels tall and not exceed 798 pixels wide and 851 pixels tall.</FormItalicHeading>
              </FormSectionPadding>

              <div>
                <div>Image 1</div>
                <FormField>
                  <CenterImage>
                    <Dropzone
                      onDrop={(acceptedFiles) => this.handleOnDrop(acceptedFiles, null, 2, true)}
                      multiple={false}
                      accept={acceptedFileTypes}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <section>
                          <ImageSelection {...getRootProps()}>
                            <input {...getInputProps()} />
                            <ABSmallButton title="File Upload" />
                            <UploadButtonContainer>
                              {this.imageCheck2()}
                              {
                                this.state.imageSizeError2 &&
                                <ValidationError>Invalid Image Size</ValidationError>
                              }
                            </UploadButtonContainer>
                          </ImageSelection>
                          {
                            this.state.uploadedFileName2 !== '' &&
                            <button onClick={() => this.setState({ uploadedFileName2: null })}>Remove X</button>
                          }
                        </section>
                      )}
                    </Dropzone>
                  </CenterImage>
                </FormField>
              </div>

              <div>
                <div>Image 2</div>
                <FormField>
                  <CenterImage>
                    <Dropzone
                      onDrop={(acceptedFiles) => this.handleOnDrop(acceptedFiles, null, 3, true)}
                      multiple={false}
                      accept={acceptedFileTypes}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <section>
                          <ImageSelection {...getRootProps()}>
                            <input {...getInputProps()} />
                            <ABSmallButton title="File Upload" />
                            <UploadButtonContainer>
                              {this.imageCheck3()}
                              {
                                this.state.imageSizeError3 &&
                                <ValidationError>Invalid Image Size</ValidationError>
                              }
                            </UploadButtonContainer>
                          </ImageSelection>
                          {
                            this.state.uploadedFileName3 !== '' &&
                            <button onClick={() => this.setState({ uploadedFileName3: null })}>Remove X</button>
                          }
                        </section>
                      )}
                    </Dropzone>
                  </CenterImage>
                </FormField>
              </div>

              <div>
                <div>Image 3</div>
                <FormField>
                  <CenterImage>
                    <Dropzone
                      onDrop={(acceptedFiles) => this.handleOnDrop(acceptedFiles, null, 4, true)}
                      multiple={false}
                      accept={acceptedFileTypes}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <section>
                          <ImageSelection {...getRootProps()}>
                            <input {...getInputProps()} />
                            <ABSmallButton title="File Upload" />
                            <UploadButtonContainer>
                              {this.imageCheck4()}
                              {
                                this.state.imageSizeError4 &&
                                <ValidationError>Invalid Image Size</ValidationError>
                              }
                            </UploadButtonContainer>
                          </ImageSelection>
                          {
                            this.state.uploadedFileName4 !== '' &&
                            <button onClick={() => this.setState({ uploadedFileName4: null })}>Remove X</button>
                          }
                        </section>
                      )}
                    </Dropzone>
                  </CenterImage>
                </FormField>
              </div>

            </FormSection>

          </FormContainer>

          <ActionButtons>
            <div></div>
            <RightButton>
              <ABButton title="Save & Close" onClick={() => this.onNextClick(true)} />
            </RightButton>
          </ActionButtons>
          {
            this.state.imageUploading &&
            <UploadSpinner>
              <Spinner />
              <div>Please wait, this could take a few minutes. Please allow for additional time if your submission includes video files.</div>
            </UploadSpinner>
          }

        </PageWrapper>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.accountInfo.loading,
    error: state.accountInfo.error,
    errorMessage: state.accountInfo.errorMessage,
    microsite: state.microsite.data,
    micrositeSetting: state.micrositeSetting.data,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getMicrosite: (id) => dispatch(getMicrosite(id)),
  getMicrositeSetting: (id) => dispatch(getMicrositeSetting(id)),
  updateMicrosite: (microsite, micrositeId, multipleCloudFrontUrls, featureProducts, gallery) => dispatch(updateMicrosite(microsite, micrositeId, multipleCloudFrontUrls, featureProducts, gallery)),
  updateMicrositeSubmission: (micrositeSubmission, micrositeId) => dispatch(updateMicrositeSubmission(micrositeSubmission, micrositeId)),
  saveSingleFile: (file, subFolder, mainFolder) => dispatch(saveSingleFile(file, subFolder, mainFolder)),
  saveMultiplePhotos: (files, companyFolder) => dispatch(saveMultiplePhotos(files, companyFolder)),
  setLocation: (page) => dispatch(setLocation(page)),
  updateMicrositeSetting: (micrositeSetting, micrositeId) => dispatch(updateMicrositeSetting(micrositeSetting, micrositeId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Focus);
